export default __webpack_public_path__ + "static/media/BLR26.0bd8e614.jpg";